<template>
    <div>
        <Menu :url="basepath" :auth="authenticate" @logoutUser="logoutUser"></Menu>

        <main>
            <Slider :url="basepath" :cliente="cliente" v-if="currenturl == '/'"></Slider>
            <!-- <Paquetes :url="basepath" :cliente="cliente" v-if="currenturl == 'paquetes'"></Paquetes> -->
            <Service :url="basepath" :cliente="cliente" v-if="currenturl == 'reservar'"></Service>
            <Terapeutas :url="basepath" :cliente="cliente" v-if="currenturl == 'terapeutas'"></Terapeutas>
            <Perfil></Perfil>
        </main>

        <ModalLogin @loginCliente="loginCliente" v-if="!authenticate" :url="basepath"></ModalLogin>
        <ModalSignUp @signupCliente="loginCliente" v-if="!authenticate" :url="basepath"></ModalSignUp>
    </div>
</template>

<script>
    import ModalSignUp from './modals/ModalSignUp'
    import ModalLogin from './modals/ModalLogin'
    import Menu from './layouts/Menu'
    import Slider from './layouts/Slider'
    import Perfil from './layouts/Perfil'
    import Service from './service/Service'
    import Terapeutas from './pages/Terapeutas'

    export default {
        components: {ModalSignUp, ModalLogin, Menu, Slider, Service, Terapeutas, Perfil},
        props: [
            'url', 
            'auth', 
            'user', 
            'currenturl'
        ],
        data() {
            return {
                authenticate: this.auth,
                cliente: this.user,
                basepath: this.url,
            }
        },
        watch: {
            authenticate: function(status){
                if(this.authenticate == true){
                    this.getAddresses()
                }
            }
        },
        methods: {
            getAddresses(){
                if(!this.cliente){
                    return
                }
                var url = '/cliente/direcciones'
                axios.post(url).then(response => {
                    this.direcciones = response.data.direcciones
                })
            },
            // emit loginCliente desde ModalLogin App
            loginCliente(cliente){
                // console.log('--- emit login cliente desde Modal ---')
                // console.log(cliente)
                this.cliente = cliente
                this.authenticate = true
            },
            logoutUser(){
                this.authenticate = false
                this.cliente = ''
                // this.$message({
                //     message: 'Has cerrado sesión correctamente, ¡vuelve pronto!',
                //     type: 'primary'
                // })
                // Habilitar para generar un alert llamativo
                Swal.fire({
                    // position: 'top-end',
                    // toast: true,
                    icon: 'success',
                    iconColor: '#18333d',
                    text: 'Has cerrado sesión correctamente',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                })
                localStorage.removeItem('user')
                setTimeout(function() {
                    location.reload()
                }, 2000);
            },
            verificarCompraPaquete(){
                // console.log('--- verificando compra paquete ---')
            }
        },
        created() {

        },
        mounted() {

        }
    };
</script>
